/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'geo-match';
const prefix = `${moduleName}.${componentName}`;

export const attributeLabel = `${prefix}.attributeLabel`;
export const attributePlaceholder = `${prefix}.attributePlaceholder`;
export const valuesMatchLabel = `${prefix}.valuesMatchLabel`;
export const valuesMatchInputPlaceholder = `${prefix}.valuesMatchInputPlaceholder`;

export const ENGLISH = {
    [attributeLabel]: 'Attribute',
    [attributePlaceholder]: 'Select Attribute',
    [valuesMatchLabel]: 'Values',
    [valuesMatchInputPlaceholder]: 'Enter Values',
};
